import DynamicFormPicklistItemDefinitionModelBase from '../_generated/modelBases/dynamic-form-picklist-item-definition-model-base';

export default class DynamicFormPicklistItemDefinitionModel extends DynamicFormPicklistItemDefinitionModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
